import { render, staticRenderFns } from "./ui-not-found.vue?vue&type=template&id=7613493f&scoped=true&"
import script from "./ui-not-found.vue?vue&type=script&lang=ts&"
export * from "./ui-not-found.vue?vue&type=script&lang=ts&"
import style0 from "./ui-not-found.vue?vue&type=style&index=0&id=7613493f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7613493f",
  null
  
)

export default component.exports